import { FC, useState } from 'react'

import { ActionButton, Box, Flex } from '@revolut-internal/ui-kit'

import { Tooltip } from 'components/Tooltip/Tooltip'
import { Security } from 'modules/security/security'
import { IncidentTimelineResponse, NextIncidentAction } from 'types'

import { QueueHealthIncidentActionModal } from './QueueHealthIncidentActionModal'
import { useIncidentActions } from './useIncidentActions'

type QueueHealthIncidentsActionsProps = {
  incident: IncidentTimelineResponse
}

export const QueueHealthIncidentsActions: FC<QueueHealthIncidentsActionsProps> = ({
  incident,
}) => {
  const [triggeredAction, setTriggeredAction] = useState<NextIncidentAction>()

  const {
    acknowledgeIncident,
    resolveIncident,

    isAcknowledgePending,
    isResolvePending,
  } = useIncidentActions()

  const handleActionClick = (action: NextIncidentAction) => {
    setTriggeredAction(action)

    if (!action.url) {
      return
    }

    window.open(action.url, '_blank')
  }

  return (
    <>
      <Flex px="s-16" pb="s-16" alignItems="center" gap="s-16">
        {Security.canAcknowledgeIncidents && !incident.isAcknowledged && (
          <ActionButton
            pending={isAcknowledgePending}
            onClick={() => acknowledgeIncident(incident.incidentId)}
          >
            Acknowledge
          </ActionButton>
        )}

        {Security.canResolveIncidents && incident.isAcknowledged && (
          <Tooltip
            message="Available once breaches are addressed"
            disabled={!incident.isBreached && !isResolvePending}
          >
            <Box>
              <ActionButton
                disabled={incident.isBreached || isResolvePending}
                onClick={() => resolveIncident(incident.incidentId)}
              >
                Resolve
              </ActionButton>
            </Box>
          </Tooltip>
        )}

        {Security.canCompleteIncidentAction &&
          incident.nextIncidentActions?.map(action => (
            <ActionButton
              key={action.incidentActionId}
              variant="black"
              onClick={() => handleActionClick(action)}
            >
              {action.label}
            </ActionButton>
          ))}
      </Flex>

      {Security.canCompleteIncidentAction && (
        <QueueHealthIncidentActionModal
          open={Boolean(triggeredAction)}
          action={triggeredAction}
          onClose={() => setTriggeredAction(undefined)}
        />
      )}
    </>
  )
}
